import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import NumberInput from '../../../components/Input/NumberInput';
import ButtonAction from '../../../components/Button.js/SaveButton';
import { sendRequest, serviceList } from 'src/utils';
import Loader from '../../../components/loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ChangeQtyRequestTakeDeviceModal = ({
    visible = false,
    callBackFunct,
    setVisible,
    setQuantity,
    quantity,
    data,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const quantityRef = useRef(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [qty, setQty] = useState(false);
    const [noteChange, setNoteChange] = useState('');
    const [flagProcess, setFlagProcess] = useState(false);
    const flagRef = React.useRef(false);

    useEffect(() => {}, []);

    const handleClick = () => {
        if (flagRef.current === true) return;
        console.log(qty);
        console.log(noteChange);
        if (!qty || !noteChange) return toast.error(t('error.param'));

        flagRef.current = true;
        setFlagProcess(true);
        let InVal = [data.id, '2', +qty || 0, '1', noteChange];
        sendRequest(serviceList.request_change_status, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        flagRef.current = false;
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            callBackFunct && callBackFunct();
        }
    };
    const timeOutFunct = (reqInfo) => {
        flagRef.current = false;
        setFlagProcess(false);
        toast.error(t('error.time_out'));
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('updateQtyTake')}
            </BootstrapDialogTitle>
            <Loader loading={flagProcess} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {/* <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <NumberInput label={t('quantity_category')} valueChange={quantity} size="medium" required />
                    </Grid> */}
                    <Grid
                        item
                        style={{ width: '100%', gap: 10, display: 'flex', flexDirection: 'column', minWidth: 350 }}
                        xl={12}
                        md={12}
                        sm={12}
                    >
                        <NumberInput
                            label={t('qtyUpdate')}
                            valueChange={qty}
                            size="medium"
                            required
                            autoFocus
                            onEnterPress={handleClick}
                            ref={quantityRef}
                            getValue={setQty}
                        />

                        <TextField
                            label={t('noteChange')}
                            valueChange={noteChange}
                            size="medium"
                            required
                            onEnterPress={handleClick}
                            ref={quantityRef}
                            onChange={(ele) => setNoteChange(ele.currentTarget.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction onClick={handleClick} type={'send'} icon="send" title={t('sendRequest')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ChangeQtyRequestTakeDeviceModal;
